import localizedCountries from '../../lib/localizedCountries';

export const mapAddressToDisplay = (
  {
    first_name: firstName,
    last_name: lastName,
    address_line1: address1,
    address_line2: address2,
    city,
    company_name: company,
    country,
    postal_code: postalCode,
    province,
  },
  languageCode,
) => ({
  firstName,
  lastName,
  company,
  address1,
  address2,
  city,
  region: province,
  country: localizedCountries(languageCode).reduce((acc, opt) => {
    if (opt.value === country) {
      return opt.label;
    }
    return acc;
  }, country),
  postalCode,
});
